import React, { useEffect, useState } from "react";
import Button from "components/button/button";
import MilestoneList from "components/milestonelist/milestonelist";
import _ from "lodash";
import LoadingIndicator from "assets/svg/loading-indicator";
import PopInfo from "components/info-popup/pop-info";
import Toggle from "components/toggle/toggle";
import { compareDate } from "utils/utils";
import { useTranslation } from "react-i18next";
import ResumeLineDividerIconSVG from "assets/svg/resume-line-divider-icon";
import { TEMPLATE_NAME_5 } from "constants/options";
// import { useResume } from "redux/modules/resume/hooks";
export default function MilestonePanel({
  userData,
  onNext,
  onBack,
  isEdit = false,
  list = {},
  show_image,
  onChangeMilestones,
  onChangeToggleImage,
  onChangeToggleImageMilestone,
  show_image_milestone = true,
  onChangeTogglePrivateMilestone,
  show_private_milestone = false,
  onChangeHidePosition,
  milestone_position,
  state = {}
}) {
  const {t} = useTranslation()
  const { http } = global.services;
  const [loading, setLoading] = useState(false);
  const [milestones, setMilestones] = useState({
    featured: [],
    current: [],
    past: [],
  });

  const title = [
    t('allFeaturedMilestones'),
   t('allCurrentMilestones'),
    t('allPastMilestones'),
  ];

  const handleChange = (key, data) => {
    onChangeMilestones(key, data);
  };

  const getMilestones = async (type) => {
    try {
      const { data } = await http.get("public/milestones/get-milestones", {
        user_profile_id: userData?.profile?.id,
        type,
      });
      if (type === "featured") {
        let arrangeFeatured = [...data].sort((a, b) => new Date(b.start_date) - new Date(a.start_date))
        setMilestones((prev) => ({
          ...prev,
          featured: arrangeFeatured,
        }));
        if (!_.isEmpty(data) && !isEdit) {
          if(!isEdit && state.templateName === TEMPLATE_NAME_5){
            onChangeMilestones("featured", []);
          }else{
            onChangeMilestones("featured", arrangeFeatured);
          }
        }
      } else {
        let arrangeCurrent = [];
        let arrangePast = [];
        data.forEach((m) => {
          if (compareDate(m) === 'upcoming') {
              arrangeCurrent.push(m);
              return;
          } else if (compareDate(m) === 'current') {
            arrangeCurrent.push(m);
            return
          } 
          else if (compareDate(m) === 'past') {
            arrangePast.push(m);
              return
          } 
        });
          arrangeCurrent = [...arrangeCurrent].sort((a, b) => new Date(b?.start_date) - new Date(a?.start_date));
          setMilestones((prev) => ({
            ...prev,
            current: arrangeCurrent,
          }));
          if (!_.isEmpty(arrangeCurrent) && !isEdit) {
            if(!isEdit && state.templateName === TEMPLATE_NAME_5){
              onChangeMilestones("current", []);
            }else{
              onChangeMilestones("current", arrangeCurrent);
            }
          }
          arrangePast = [...arrangePast].sort((a, b) => new Date(b?.start_date) - new Date(a?.start_date))
          setMilestones((prev) => ({
            ...prev,
            past: arrangePast,
          }));
          if (!_.isEmpty(arrangePast) && !isEdit) {
            if(!isEdit && state.templateName === TEMPLATE_NAME_5){
              onChangeMilestones("past", []);
            }else{
              onChangeMilestones("past", arrangePast);
            }
          }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getAll = async () => {
    setLoading(true);
    await Promise.all([
      getMilestones("featured"),
      getMilestones("current"),
      // getMilestones("past"),
    ])
      .then(() => {
        setLoading(false);
      })
      .catch((error) => {
        console.error(`Failed to fetch: ${error}`);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (!_.isEmpty(userData)) {
      getAll();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  return (
    <div className="w-full h-full border-r border-resumeBorder">
      <div
        className="w-full overflow-y-auto overflow-x-hidden custom-scroll"
        style={{ height: "calc(100vh - 174px)" }}>
        <div className="w-full px-2 2sm:px-15.5 pb-10.6 pt-5">
          {
            state.templateName === "Template Name 5" &&
            <>
            <div className="text-center text-lightBlack text-xl font-semibold">
              Select 10 milestones
            </div>
            </>
          }
          
          {
            state.templateName !== "Template Name 5" && 
            <>
            <div className="w-full">
              <ResumeLineDividerIconSVG full={true} />
            </div>
            <div className="flex items-center flex-col 2sm:flex-row mt-4 sticky top-0 z-10 bg-white py-2">
              <div className="w-full flex flex-row gap-x-2 items-center">
                <h1 className="text-lightBlack text-sm 2sm:text-md font-semibold">
                  {t('showHideMilestones')}
                </h1>
                <PopInfo containerClass="relative" type="show_hide_milestones" />
              </div>

              <div className="w-full 3md:w-14/20 flex flex-row flex-nowrap items-center justify-start 2sm:justify-end gap-x-5">
                <div className="flex flex-row flex-nowrap items-center gap-x-2 min-w-0">
                  <div className="shrink-0">
                    <Toggle
                      checked={show_image_milestone}
                      name="dateFormat"
                      onChange={(e) => onChangeToggleImageMilestone(e?.target?.checked)}
                    />
                  </div>
                  <p className="text-xs font-medium text-lightBlack leading-tight min-w-0">
                    {t('showHideImages')}
                  </p>
                </div>

                {/* Show/Hide Private Milestones — off by default hides private
                    milestones from the resume. (Marker.io MCF-1827) */}
                <div className="flex flex-row flex-nowrap items-center gap-x-2 min-w-0">
                  <div className="shrink-0">
                    <Toggle
                      checked={show_private_milestone}
                      name="showPrivateMilestones"
                      onChange={(e) =>
                        onChangeTogglePrivateMilestone &&
                        onChangeTogglePrivateMilestone(e?.target?.checked)
                      }
                    />
                  </div>
                  <p className="text-xs font-medium text-lightBlack leading-tight min-w-0">
                    {t('showHidePrivateMilestones', 'Show/Hide Private Milestones')}
                  </p>
                </div>
              </div>
            </div>
            </>
            
          }

          {loading ? (
            <div
              className="flex flex-col justify-center items-center text-primary"
              style={{ height: "calc(100vh - 300px)" }}>
              <LoadingIndicator className="w-10 h-10" />
              <p className="text-secondary">
                {t('loadingMilestone')}
              </p>
            </div>
          ) : (
            <div className="w-full mt-4">
              {Object.keys(milestones).map((k, i) => {
                let content = isEdit ? list[k] : state.templateName !== TEMPLATE_NAME_5 ? milestones[k] : [];
                return (
                  <MilestoneList
                    key={`${k}-${i}`}
                    name={k}
                    title={title[i]}
                    content={content}
                    isEdit={isEdit}
                    milestones={milestones[k]}
                    onChange={(key, data) => handleChange(key, data)}
                    onChangeHidePosition={onChangeHidePosition}
                    milestone_position={milestone_position}
                    allMilestone = {list}
                    state={state}
                  />
                );
              })}
            </div>
          )}

        </div>
      </div>
      {/* footer */}
      <div className="w-full py-4 px-6 border-t border-resumeBorder">
        <div className="w-full flex justify-center 2sm:justify-end space-x-5">
          <Button
            buttonName={t('back')}
            buttonTextClass="text-sm font-semibold text-lightBlack"
            buttonRadius="6px"
            buttonClass="bg-thBg px-12 py-3 2sm:px-17.5 2sm:py-5"
            onClick={onBack}
          />
          <Button
            buttonName={t('next')}
            buttonTextClass="text-sm font-semibold text-white"
            buttonRadius="6px"
            buttonClass="bg-primary px-12 py-3 2sm:px-17.5 2sm:py-5"
            onClick={onNext}
          />
        </div>
      </div>
    </div>
  );
}
